import { FormGridField } from "../../components/FormGrid";

export interface SwitchDefinition {
    name: string;
    id: string;
    label: string;
    schemaName: string;
    fieldOverrides?: any;
    disabled?: boolean;
    buildFormGridField: (schema) => FormGridField;
}

export default function buildSwitchDefinition({
    name,
    id,
    label,
    schemaName,
    fieldOverrides,
    disabled
}: {
    name: string;
    id: string;
    label: string;
    schemaName: string;
    fieldOverrides?: any;
    disabled?: boolean;
}): SwitchDefinition {
    return {
        name,
        id,
        label,
        schemaName,
        fieldOverrides,
        disabled,
        buildFormGridField: _createSwitchField
    };
}

function _createSwitchField(schema): FormGridField {
    const { name, id, label, schemaName, fieldOverrides, disabled } = this;

    return {
        name,
        fieldType: "switch",
        fieldOptions: {
            id,
            label,
            disabled
        },
        validationSchema: {
            ...schema.properties[schemaName],
            required: schema.hasOwnProperty("required")
                ? schema.required.includes(name)
                : false
        },
        columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6",
        formSpacing: true,
        ...fieldOverrides
    };
}
